export default __webpack_public_path__ + "static/media/a2.45d4b81c.png";